import _ from 'lodash'
import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'
import type {
  PaymentIntentContext,
  BuyerPaymentType,
  TransactionContextIdentifierInput,
} from '@adc/sdk/types'
import { embeddableOperation } from './utils'

export const createPaymentIntent = (
  paymentType: BuyerPaymentType,
  contextIdentifier?: TransactionContextIdentifierInput
) => {
  return fetch
    .forAuctionGraph<'createPaymentIntent', PaymentIntentContext>({
      query: gql`
        mutation ${embeddableOperation('toolkitCore_createPaymentIntent')}(
          $type: BuyerPaymentType!,
          $input: TransactionContextInput
        ) {
          createPaymentIntent(type: $type, input: $input) {
            client_secret
          }
        }
        `,
      variables: {
        type: paymentType,
        input: {
          context_identifier: contextIdentifier,
        },
      },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res.body.data.createPaymentIntent
    })
}

export const capturePaymentMethodForRefund = (
  paymentType: BuyerPaymentType,
  contextIdentifier?: TransactionContextIdentifierInput,
  req?: any
) => {
  return fetch
    .forAuctionGraph<'capturePaymentMethodForRefund', PaymentIntentContext>(
      {
        query: gql`
          mutation ${embeddableOperation(
            'toolkitCore_capturePaymentMethodForRefund'
          )}(
            $type: BuyerPaymentType!,
            $input: TransactionContextInput
          ) {
            capturePaymentMethodForRefund(type: $type, input: $input) {
              client_secret
            }
          }
        `,
        variables: {
          type: paymentType,
          input: {
            context_identifier: contextIdentifier,
          },
        },
      },
      { req }
    )
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res.body.data.capturePaymentMethodForRefund
    })
}
